/**
 * i18n configuration — react-i18next with namespace-based translation files.
 * Sprint 10.3: Initial i18n adoption.
 *
 * Namespaces:
 *   common — shared UI chrome (buttons, labels, pagination)
 *   auth   — login, session selection, MFA
 *   pki    — certificates, SSH, ACME, dashboard
 *
 * Supported locales: en (default), es (proof locale).
 * Browser language detection enabled — falls back to 'en'.
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import commonEn from './locales/en/common.json';
import authEn from './locales/en/auth.json';
import pkiEn from './locales/en/pki.json';

import commonEs from './locales/es/common.json';
import authEs from './locales/es/auth.json';
import pkiEs from './locales/es/pki.json';

export const supportedLanguages = [
  { code: 'en', label: 'English' },
  { code: 'es', label: 'Español' },
] as const;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { common: commonEn, auth: authEn, pki: pkiEn },
      es: { common: commonEs, auth: authEs, pki: pkiEs },
    },
    defaultNS: 'common',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // React already escapes
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'vortex-lang',
    },
  });

export default i18n;
